import "./global.css";

import { Button, Form, Input, Layout, Modal, message } from "antd";
import React, { Component } from "react";

import Api from "./../../helpers/apiHandler";
import AppHolder from "./commonStyle";
import AppRouter from "./AppRouter";
import Loader from "../../components/utility/loader";
import Sidebar from "../Sidebar/Sidebar";
import { ThemeProvider } from "styled-components";
import Topbar from "../Topbar/Topbar";
import WindowResizeListener from "react-window-size-listener";
import appActions from "../../redux/app/actions";
import authAction from "../../redux/auth/actions";
import { connect } from "react-redux";
import { loginUserType } from "../../helpers/constants";
import { siteConfig } from "../../settings";
import { themeConfig } from "../../settings";
import themes from "../../settings/themes";
import Counts from "../../components/Counts";
import UsdaUpdatePrompt from "../../components/ingredients/UsdaUpdatePrompt";
import { DateFormatProvider } from "../../context/DateFormatContext";
import { CurrencyProvider } from "../../context/CurrencyContext";

const api = new Api();
let timeoutVar;
const { Content, Footer } = Layout;
const { logout, updateProfile } = authAction;
const { toggleAll, changeCurrent } = appActions;
const FormItem = Form.Item;


export class App extends Component {
  state = {
    isLoading: false,
    isAddModalVisible: false,
    selectedCompany: null,
    selectedProductionUnit: null,
    collapsed: true,
    collapsedWidth: 0,
    _767: false,
    _1199: false,
    isFeedbackAddModalVisible: false,
    submitLoading: false,
  };

  formatPageName = (pathname) => {
    if (!pathname) return 'Home';
    return pathname
      .split('/')
      .filter(segment => segment && segment.trim()) // Remove empty segments and whitespace
      .map(segment => segment.replace(/[_-]/g, ' ')) // Replace underscores and hyphens with spaces
      .map(segment => segment.replace(/[0-9]/g, '')) // Remove numbers
      .map(segment => segment.trim()) // Remove extra spaces
      .filter(segment => segment) // Remove any empty segments
      .map(segment => segment.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')) // Capitalize each word
      .join(' ') || 'Home'; // Join with spaces, default to 'Home' if empty
  };

  showModal = () => {
    this.setState({ isFeedbackAddModalVisible: true });
  };

  handleCancel = () => {
    this.props.form.resetFields(); // Reset all form fields to empty
    this.setState({ isFeedbackAddModalVisible: false });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        // console.log("Form values: ", values);
        this.handleCancel();
      }
    });
  };

  constructor(props) {
    super(props);
    this.handleWindowSizeChange = this.handleWindowSizeChange.bind(this);
    this.toggleCollapsed = this.toggleCollapsed.bind(this);
  }

  componentDidMount() {
    const { id, type } = this.props.auth;
    if (id && type !== "superadmin") {
      this.getData(this.props);
    }
    if (this.state._1199 || this.state._767) {
      this.setState({ collapsed: true });
    } else {
      this.setState({ collapsed: true });
    }
    this.handleWindowSizeChange();
    window.addEventListener("resize", this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowSizeChange);
  }

  componentDidUpdate(prevProps, prevState) {
    const { pathname, search, hash } = this.props.location || {};
    if (pathname && pathname.length > 1 && pathname.endsWith("/")) {
      this.props.history.replace({
        pathname: pathname.replace(/\/+$/, ""),
        search,
        hash,
      });
      return;
    }

    if (this.props && this.props.location && this.props.location.pathname) {
      const urlArray = this.props.location.pathname.split("/");
      if (urlArray.length > 0 && urlArray[1])
        this.props.changeCurrent([urlArray[1]]);
    }
    if (
      prevState._767 !== this.state._767 ||
      prevState._1199 !== this.state._1199
    ) {
      if (this.state._767) {
        this.setState({ collapsed: true, collapsedWidth: 0 });
      } else if (this.state._1199) {
        this.setState({ collapsed: true, collapsedWidth: 0 });
      } else {
        this.setState({ collapsed: true, collapsedWidth: 0 });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.auth.id != nextProps.auth.id) {
      const { id, type } = nextProps.auth;
      if (id && type !== "superadmin") {
        this.getData(nextProps);
      }
    }
  }

  getData(callProps) {
    this.setState({ isLoading: true });

    // let admin_data = JSON.parse(localStorage.getItem('user'));
    const url = "company/list/" + callProps.auth.id;
    const existingCompanyId = Number(callProps.auth.company && callProps.auth.company.id);
    api
      .get(url)
      .then((response) => {
        this.setState({ isLoading: false });
        if (response.status === 1) {
          const companies =
            response.data.companyList ||
            response.data.list ||
            [];
          if (!Array.isArray(companies) || companies.length === 0) {
            if (
              callProps.auth.type === loginUserType.employee &&
              Number.isFinite(existingCompanyId) &&
              existingCompanyId > 0
            ) {
              return;
            }
            return;
          }
          const result = companies.filter((record) => {
            return record.productionUnitCount > 0;
          });

          this.setState({ selectedCompany: companies[0] });
          callProps.updateProfile({ company: companies[0] });

          if (result.length > 0) {
            this.getProductionUnitList();
          } else {
            this.setState({
              isLoading: true,
              isAddModalVisible: true,
            });
          }
        }
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        return error;
      });
  }

  getProductionUnitList() {
    let url =
      "companyProductionUnit/list/" + this.state.selectedCompany.id.toString();

    this.setState({ isLoading: true });

    this.state.selectedCompany.id.toString() &&
      api
        .get(url)
        .then((response) => {
          this.setState({ isLoading: false });
          if (response.status === 1) {
            let productionUnits = response.data.companyProductionUnitList;

            this.setState({
              selectedProductionUnit: productionUnits[0],
            });
          } else {
            // console.log("!200");
          }
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          return error;
        });
  }

  toggleCollapsed() {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }));
  }

  handleWindowSizeChange() {
    const _767 = window.matchMedia("(max-width: 767px)").matches;
    const _1199 = window.matchMedia(
      "(min-width: 767px) and (max-width: 1200px)"
    ).matches;
    
    // Only update state if values actually changed
    if (_767 !== this.state._767 || _1199 !== this.state._1199) {
      this.setState({ _767, _1199 });
    }
    // this.setState({ _767, _1199 });
  }

  dismissVersionNotification = () => {
    this.setState({ newVersionAvailable: false });
  };

  render() {
    const { url } = this.props.match;
    const { height } = this.props;
    const { getFieldDecorator } = this.props.form;
    const { validateFieldsAndScroll } = this.props.form;
    const handleFeebackSubmit = (e) => {
      e.preventDefault();
      const link = window.location.href; // Get the current page URL
      const pageName = this.formatPageName(window.location.pathname);
      
      this.setState({ submitLoading: true }); // Start loading

      validateFieldsAndScroll((err, values) => {
        if (!err) {
          api
            .post("feedback/add", {
              isMultipart: false,
              data: {
                companyId: this.props.company.id,
                link: link, // Send the URL if needed
                userId: this.props.auth.id,
                page: pageName, // Use page name as subject
                description: values.description,
                subject: values.subject,
              },
            })
            .then((response) => {
              this.setState({ submitLoading: false }); // Stop loading
              if (response.status === 1) {
                this.handleCancel();
                message.success(response.message);
              } else {
                message.error(response.message);
              }
            })
            .catch((error) => {
              this.setState({ submitLoading: false }); // Stop loading in case of error
              message.error("An error occurred. Please try again.");
              return error;
            });
        } else {
          this.setState({ submitLoading: false }); // Stop loading if validation fails
        }
      });
    };

    return (
      <ThemeProvider theme={themes[themeConfig.theme]}>
        <DateFormatProvider>
          <CurrencyProvider companyId={this.props.company && this.props.company.id}>
            <AppHolder>
            <Layout style={{ height: "100vh" }}>
              <WindowResizeListener
                onResize={(windowSize) => {
                  if (timeoutVar) {
                    clearTimeout(timeoutVar);
                  }
                  timeoutVar = setTimeout(() => {
                    this.props.toggleAll(
                      windowSize.windowWidth,
                      windowSize.windowHeight
                    );
                  }, 1000);
                }}
              />
              <Layout
                style={{
                  flexDirection: "row",
                  overflowX: "hidden",
                }}
              >
                <Sidebar
                  url={url}
                  collapsed={this.state.collapsed}
                  collapsedWidth={this.state.collapsedWidth}
                  siderStyle={
                    this.state._1199
                      ? { position: "fixed", left: 0, top: 0, bottom: 0 }
                      : this.state._767
                        ? { position: "fixed", left: 0, top: 0, bottom: 0 }
                        : { position: "fixed", left: 0, top: 0, bottom: 0 }
                  }
                  // showCollapseBtn={
                  //   (this.state._1199 || this.state._767) && !this.state.collapsed
                  // }
                  showCollapseBtn={!this.state.collapsed}
                  handleSidebarCollapsedBtnClick={this.toggleCollapsed}
                />
                <Layout
                  className="isoContentMainLayout"
                  style={
                    this.state._767
                      ? { height: "100vh" }
                      : this.state._1199
                        ? {
                          height: "100vh",
                          // marginLeft: "80px",
                        }
                        : { height: "100vh" }
                  }
                >
                  <Topbar
                    url={url}
                    companyName={this.props.auth.company.name}
                    toggleCollapsed={this.toggleCollapsed}
                    isSmallScreen={this.state._1199 || this.state._767}
                  />
                  <div className="flex-1 display-flex flex-column">
                    <Counts />
                    <Content
                      className="isomorphicContent"
                      style={{
                        padding: 0,
                        flexShrink: "0",
                        background: "#f1f3f6",
                        position: "relative",
                      }}
                    >
                      <AppRouter url={url} />
                      {/* Super Admin USDA changes waiting for this company's permission */}
                      {this.props.auth &&
                        this.props.auth.id &&
                        this.props.authType &&
                        this.props.authType !== loginUserType.superadmin && <UsdaUpdatePrompt />}
                      {/* ADD MODAL HERE */}
                      <div>
                        <Modal
                          visible={this.state.isFeedbackAddModalVisible}
                          footer={null}
                          className="generalModal"
                          onCancel={this.handleCancel} // Call handleCancel on close
                        >
                          <p
                            className="f-size-24px pa-bottom-16px"
                            style={{ fontWeight: 500, color: "#262626" }}
                          >
                            Add Details
                          </p>
                          <Form onSubmit={handleFeebackSubmit} className="isoForm">
                            <div className="pa-bottom-12px">
                              <Form.Item className="customFormItem" label="Page">
                                {getFieldDecorator("page", {
                                  initialValue: this.formatPageName(window.location.pathname),
                                  rules: [{ required: true, message: "Please input subject." }],
                                })(<Input disabled />)}
                              </Form.Item>
                            </div>
                            <div className="pa-bottom-12px">
                              <Form.Item className="customFormItem" label="Subject">
                                {getFieldDecorator("subject", {
                                  initialValue: null,
                                  rules: [{ required: true, message: "Please input subject." }],
                                })(<Input />)}
                              </Form.Item>
                            </div>
                            <div className="pa-bottom-12px">
                              <Form.Item className="customFormItem" label="Description">
                                {getFieldDecorator("description", {
                                  initialValue: null,
                                  rules: [{ required: true, message: "Please input description." }],
                                })(<Input.TextArea rows={4} />)}
                              </Form.Item>
                            </div>
                            <div className="display-flex gap-12px pa-top-20px">
                              <Button type="primary" htmlType="submit" loading={this.state.submitLoading}>Submit</Button>
                              <Button onClick={this.handleCancel}>Cancel</Button>
                            </div>
                          </Form>
                        </Modal>
                      </div>
                    </Content>
                    <Footer
                      style={{
                        background: "#ffffff",
                        display: "flex",
                        justifyContent: "center", // Centers the text initially
                        alignItems: "center",
                        position: "relative", // Needed for absolute positioning of the button
                        borderTop: "1px solid #ededed",
                        padding: "10px 16px",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >
                      {/* Centered Footer Text */}
                      <span>{siteConfig.footerText}</span>
                
                      {/* Right Side - Message + Button */}
                      {this.props.auth.type !== "superadmin" && (
                        <div
                          style={{
                            position: "absolute",
                            right: "217px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            maxWidth: "320px",
                            textAlign: "right",
                          }}
                        >
                          <span style={{ fontSize: "13px", whiteSpace: "nowrap" }}>
                            Do you have an idea how this page or feature can be improved?
                          </span>
                          <Button type="primary" className="submit-feedback" onClick={this.showModal}>
                            Submit Feedback
                          </Button>
                        </div>
                      )}
                    </Footer>
                  </div>
                </Layout>
                {(this.state._1199 || this.state._767) &&
                  this.state.collapsed == false ? (
                  <div className="layoutOverlay"></div>
                ) : (
                  ""
                )}
              </Layout>
            </Layout>


          </AppHolder>
          </CurrencyProvider>
        </DateFormatProvider>
      </ThemeProvider>
    );
  }
}

// export default connect(
//   state => ({
//     auth: state.Auth,
//     height: state.App.toJS().height
//   }),
//   { logout, toggleAll }
// )(App);

const mapStateToProps = (state) => ({
  company: state.Auth.company,
  auth: state.Auth,
  height: state.App.toJS().height,
  authType: state.Auth.type,
});

export default Form.create()(
  connect(mapStateToProps, { logout, toggleAll, updateProfile, changeCurrent })(
    App
  )
);
